import { render, staticRenderFns } from "./warehouseStorageLocation.vue?vue&type=template&id=50cd4ad2&"
import script from "./warehouseStorageLocation.vue?vue&type=script&lang=js&"
export * from "./warehouseStorageLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50cd4ad2')) {
      api.createRecord('50cd4ad2', component.options)
    } else {
      api.reload('50cd4ad2', component.options)
    }
    module.hot.accept("./warehouseStorageLocation.vue?vue&type=template&id=50cd4ad2&", function () {
      api.rerender('50cd4ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/warehouseStorageLocation.vue"
export default component.exports